<template>
	<div class="login-body">
		<div class="login-panel"></div>

        <div class="login-content">
			<div class="grid">
				<div class="col-4 md:col-2">
					<img style="width: 150px; margin: 0px" src="assets/layout/images/logo_tribunal.png" alt="tce-am"/>
				</div>
				<div class="col-6 md:col-6 flex justify-content-start" style="margin: 1rem;">
					<h1><span style="font-size: 2rem; color: black">TRIBUNAL DE CONTAS DO</span>
					<br>ESTADO DO AMAZONAS</h1>
				</div>
			</div>

    <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(redefinirSenha)">
		<div class="card col-12 md:col-5 shadow-22">
            <h1>Sistema de Processos Seletivos</h1>
            <h4>Recuperar Senha</h4>
            <p>
                Digite o endereço de e-mail que foi cadastrado em sua conta, em seguida acesse a sua caixa de entrada para acessar o link de recuperação de senha.
            </p>
            <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">{{msg.content}}</Message>
            <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-12">
                    <label for="email" class="required">E-mail</label>
                    <ValidationProvider name="E-mail" rules="required|email" vid="email" v-slot="{ errors }" mode="lazy">
                        <span class="p-input-icon-left">
                                <i class="pi pi-envelope" />
                            <InputText id="email" v-model="usuario.email" :class="{ 'field-invalid': errors[0] }" placeholder="E-mail"/>
                        </span>
                        <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                    </ValidationProvider>
                </div>
                <div class="formgroup-inline">
                    <div class="m-2">
                        <Button label="Recuperar a senha" type="submit" icon="pi pi-check" iconPos="left" style="width: 160px"></Button>
                    </div>
                    <div class="m-2">
                        <router-link :to="{ name: 'login'}">
                            <Button label="Login" icon="pi pi-arrow-circle-left" iconPos="left" class="p-button-secondary" style="width: 160px"></Button>
                        </router-link>
                    </div>
                </div>
            </div>
    </div>
</form>
</ValidationObserver>
</div>
</div>
</template>

<script>

import { validacaoFormulario } from '@/validacaoFormulario'
import http from '@/http'

export default {

mixins: [validacaoFormulario],

data() {
        return {
            messages: [],
            usuario:{
                email:''
            }
        };
    },

    methods: {

        redefinirSenha(){

            console.log('redefinirSenha ...');
            console.log('Body requisição: ' + JSON.stringify(this.usuario))
            this.messages=[];
            http.post('auth/forgot', this.usuario)
                .then(resposta => {
                    resposta.response;
                    this.messages = [{severity: 'success', content: `Caso o e-mail ${this.usuario.email} esteja cadastrado, será enviado um e-mail de recuperação de senha. Verifique sua caixa de entrada`}];
                })
                .catch(erro =>  {
                    if(erro.response){
                        this.messages = [{severity: 'error', content: erro.response.data.message}];
                    }else{
                        this.messages = [{severity: 'error', content: 'Sistema indisponível! Tente novamente mais tarde.'}];
                    }
                })

        }
	}

}
</script>